import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _types$SET_WISHLIST$t;

import * as types from './types';
export default (_types$SET_WISHLIST$t = {}, _defineProperty(_types$SET_WISHLIST$t, types.SET_WISHLIST, function (state, payload) {
  var currentState = state;
  currentState.product = payload.product;
}), _defineProperty(_types$SET_WISHLIST$t, types.SET_LOADING_WISHLIST, function (state, payload) {
  var currentState = state;
  currentState.loading = payload;
}), _defineProperty(_types$SET_WISHLIST$t, types.ADD_WISHLIST_ITEM, function (state, payload) {
  var currentState = state;
  currentState.product.push(payload.reference);
}), _defineProperty(_types$SET_WISHLIST$t, types.DELETE_WISHLIST_ITEM, function (state, payload) {
  var currentState = state;
  currentState.product.splice(currentState.product.indexOf(payload.reference), 1);
}), _types$SET_WISHLIST$t);